import { styled } from "theme/default/styled";
import { setFontSize_12px } from "theme/setter/setFontSizeValues/setFontSize_12px";

export const SSupportPageQuestionDescription = styled.div`
  margin-left: 24px;

  ${setFontSize_12px};
`;
